import { render, staticRenderFns } from "./pkgTransfer.vue?vue&type=template&id=0cfae273&scoped=true&"
import script from "./pkgTransfer.vue?vue&type=script&lang=js&"
export * from "./pkgTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfae273",
  null
  
)

export default component.exports